export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-6e-52ce36459a6ff87de58c16ddd8b962ef.webp";